export default {
  getProfile: (state) => state.profile,
  isLoading: (state) => state.loading,
  getError: (state) => state.error,
};
